angular.module('cfn').factory('cfnGridTemplates', function() {
  return {
    pagination:
      "<div ng-show='view.pageCount>1' " +
      "class='pagination'>" +
      "<span class='formathelper'>" +
      "<span class='formathelper-top'>" +
      "<button type='button' " +
      "class='btn pageinationBtn prev' " +
      "ng-disabled='view.currentPage === 1' " +
      "ng-click='changeViewPage(view.currentPage-2)'>" +
      '&lt;' +
      '</button>' +
      "<button type='button' " +
      "class='btn pageinationBtn pages' " +
      "ng-repeat='page in view.pages' " +
      'ng-class=\'{"active":page.selected}\' ' +
      "ng-click='changeViewPage(page.number-1, $event)'>" +
      '{{page.number}}' +
      '</button>' +
      "<button type='button' " +
      "class='btn pageinationBtn next' " +
      "ng-disabled='view.currentPage === view.pages.length' " +
      "ng-click='changeViewPage(view.currentPage)'>" +
      '&gt;' +
      '</button>' +
      '</span>' +
      '</span>' +
      '</div>',
    loading:
      "<div ng-show='view.loading' " +
      "style='position:absolute;top:0px;left:0px;width:100%;height:100%;background:rgba(0,0,0,0.0)'>" +
      "<div class='loadingCircleDiv' " +
      "style='position:relative;' " +
      'ng-style=\'{top:((height-headerHeight)*0.5-20)+"px",left:((width*0.5)-20)+"px"}\' >' +
      "<img style='padding:2px;' src='img/ajax-loader-circle.gif'/>" +
      '</div>' +
      '</div>'
  };
});
